jQuery(function () {

    jQuery('body').on('click', 'tr.table__row--clickable', function (e) {
        var $row = jQuery(this);
        var $svg = $row.children('td').children('.table__column-svg-container');
        var $hidden_row = $row.next('.table__row-extra-data');
        //storeResize()
        if ($row.hasClass('table__row--open')) {
            $row.removeClass('table__row--open');
            $hidden_row.addClass('table__row--hidden');
            $svg.removeClass('rotate');
        } else {
            $row.addClass('table__row--open');
            $hidden_row.removeClass('table__row--hidden');
            $svg.addClass('rotate');
        }
    });

    jQuery('body').on('click', '.store-accordion__button, .table-accordion__button', function () {
        var $button = jQuery(this)
            $clickableRow = $button.parent(".table__column").parent(".table__row--clickable");
            $clickableRow.hasClass("table__row--open") ? $button.attr("aria-expanded", "false") : $button.attr("aria-expanded", "true");
           
            // $clickableRow.next(".table__row-extra-data").find(".table__label:first").attr({
            //     "aria-atomic":"true",
            //     "aria-live":"assertive",
            //     "tabindex":"-1"
            // });

    });

    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    }

    var OS = getMobileOperatingSystem();

    function storeResize() {
        var $row_select = jQuery("#storesTable .table__row-extra-data:visible, #storesTable .table__row--clickable:visible");
        var $row_select_all = jQuery("#storesTable .table__row-extra-data, #storesTable .table__row--clickable");
        if (window.innerWidth >= 600) {
            $row_select.css('display', 'table-row');
            //$row_select_all.css('display', 'table-row');
        }
        else {
            $row_select.css('display', 'block');
        }
    }

    //On resize need to add appropriate disply property else the rendering is broken
    window.onresize = function () {
        storeResize();
    };

    //when user clicks load more button we need to add disply property else rendering is broken
    jQuery(".table__load-more #store-load-morex").click(function () {
        setTimeout(function () {
            storeResize();
        }, 50);
    });
    //Put on the page in sitecore as this is causing issue with moneris iframe
    // jQuery('tr.table__row--clickable').on('click touchstart', function (e){
    //     if (window.innerWidth < 600) {
    //     jQuery(this).next(".table__row-extra-data").css("display", "block");
    //     }
    // });
});